// removed by extract-text-webpack-plugin
module.exports = {"section":"section","custom-select":"custom-select"};


//////////////////
// WEBPACK FOOTER
// ./components/vitrade-forms/_SubCategorySelectorInput.scss
// module id = ./components/vitrade-forms/_SubCategorySelectorInput.scss
// module chunks = 0